const axios = require('axios'),
    URLSearchParams = require('url-search-params'),
    _ = require('lodash');
function getXsrf()
{
    if(window.hasOwnProperty('xsrfToken'))
    {
        return {'X-XSRF-TOKEN':window.xsrfToken};
    }
    return {};
}


export default {
    post(url, data = {}) {
        const params = new URLSearchParams();
        _.forEach(data,function (value, key) {
            params.append(key, value);
        })
        return axios({
            method: 'post',
            url: url,
            data: params,
            headers:_.assign(getXsrf(),{}),
            validateStatus: function (status) {
                return status < 500; // Reject only if the status code is greater than or equal to 500
            }
        });

    }
}
